import type { IconProps } from '../types/IconProps.ts';
export const LinkOff: IconProps = {
    name: 'LinkOff',
    children: [
        `<path d="m16 15 3.75-3.72a4.99 4.99 0 1 0-7.04-7.06M8 9l-3.75 3.72a4.99 4.99 0 1 0 7.04 7.06M2 2l20 20" />`,
    ]
};